/* Haven product enhancement: variant selection and recommendations stay native-first. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function all(scope, selector) {
    if (!scope || !scope.querySelectorAll) return [];
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  function first(scope, selector) {
    return scope && scope.querySelector ? scope.querySelector(selector) : null;
  }

  function parseVariants(section) {
    var node = first(section, '[data-variant-data]');
    if (!node) return [];
    try {
      var parsed = JSON.parse(node.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function variantId(variant) {
    return variant && variant.id != null ? String(variant.id) : '';
  }

  function optionControls(section) {
    return all(section, '[data-option-value]');
  }

  function optionPositions(section) {
    var positions = {};
    optionControls(section).forEach(function (control) {
      var position = String(control.dataset.optionPosition || '');
      if (position) positions[position] = true;
    });
    return Object.keys(positions).sort(function (a, b) { return Number(a) - Number(b); });
  }

  function selectedOptions(section) {
    var selected = {};
    optionControls(section).forEach(function (control) {
      if (control.classList.contains('is-selected')) {
        selected[String(control.dataset.optionPosition)] = control.dataset.optionValueName || '';
      }
    });
    return selected;
  }

  function setSelectedOptions(section, selected) {
    optionControls(section).forEach(function (control) {
      var position = String(control.dataset.optionPosition || '');
      var value = control.dataset.optionValueName || '';
      var isSelected = selected[position] != null && selected[position] === value;
      control.classList.toggle('is-selected', isSelected);
      control.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function updateOptionLegends(section, selected) {
    all(section, '[data-option-selected-label]').forEach(function (label) {
      label.textContent = selected[String(label.dataset.optionPositionLabel || '')] || '';
    });
  }

  function variantForSelection(variants, positions, selected) {
    if (!positions.length) return null;
    for (var i = 0; i < variants.length; i += 1) {
      var options = variants[i].options || [];
      var matches = positions.every(function (position) {
        var index = Number(position) - 1;
        return selected[position] != null && String(options[index] == null ? '' : options[index]) === String(selected[position]);
      });
      if (matches) return variants[i];
    }
    return null;
  }

  function variantById(variants, id) {
    var wanted = String(id || '');
    if (!wanted) return null;
    for (var i = 0; i < variants.length; i += 1) {
      if (variantId(variants[i]) === wanted) return variants[i];
    }
    return null;
  }

  function setPrice(section, variant) {
    var price = first(section, '[data-product-price]');
    if (!price || !variant) return;
    var current = first(price, '.price__current');
    if (!current) {
      current = document.createElement('span');
      current.className = 'price__current';
      price.appendChild(current);
    }
    current.textContent = variant.price_formatted || '';
    var professional = first(price, '[data-professional-price]');
    var professionalRow = first(price, '[data-professional-price-row]');
    if (professional) professional.textContent = variant.professional_price_formatted || '';
    if (professionalRow) professionalRow.hidden = !variant.professional_price_formatted;

    var compare = first(price, '.price__compare');
    var hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
    if (hasCompare) {
      if (!compare) {
        compare = document.createElement('span');
        compare.className = 'price__compare';
        var strike = document.createElement('s');
        compare.appendChild(strike);
        price.appendChild(compare);
      }
      var strikeNode = first(compare, 's');
      if (strikeNode) strikeNode.textContent = variant.compare_at_price_formatted || '';
    } else if (compare) {
      compare.remove();
    }
  }

  function clearPrice(section) {
    var price = first(section, '[data-product-price]');
    if (!price) return;
    var current = first(price, '.price__current');
    if (current) current.textContent = '';
    var professional = first(price, '[data-professional-price]');
    var professionalRow = first(price, '[data-professional-price-row]');
    if (professional) professional.textContent = '';
    if (professionalRow) professionalRow.hidden = true;
    var compare = first(price, '.price__compare');
    if (compare) compare.remove();
    var from = first(price, '.price__from');
    if (from) from.remove();
  }

  function stopMedia(section) {
    if (section.productVideoObserver) section.productVideoObserver.disconnect();
    all(section, '[data-product-media-slot] video').forEach(function (video) {
      video.pause();
      all(video, 'source[src]').forEach(function (source) { source.removeAttribute('src'); });
      video.removeAttribute('src');
      video.load();
    });
  }

  function activateMedia(section) {
    if (section.productVideoObserver) section.productVideoObserver.disconnect();
    var video = first(section, '[data-product-media-slot] [data-deferred-product-video]');
    if (!video) return;
    function start() {
      if (!video.isConnected) return;
      if (!video.dataset.loaded) {
        var sources = all(video, 'source[data-src]');
        // Prefer progressive MP4: native HLS support varies between browsers.
        var mp4 = sources.filter(function (source) { return source.type === 'video/mp4'; });
        var playable = mp4.length ? mp4 : sources;
        playable.forEach(function (source) { source.src = source.dataset.src; });
        // Empty <source> elements must not precede the selected format.
        sources.forEach(function (source) {
          if (playable.indexOf(source) === -1) source.remove();
        });
        video.dataset.loaded = 'true';
        video.muted = true;
        video.preload = 'auto';
        video.load();
      }
      if (!reducedMotion) {
        var playback = video.play();
        if (playback && playback.catch) playback.catch(function () { /* Native controls remain available. */ });
      }
    }
    if (!window.IntersectionObserver) { start(); return; }
    section.productVideoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) start();
        else video.pause();
      });
    }, { threshold: 0.1 });
    section.productVideoObserver.observe(video);
  }

  function setMedia(section, variant) {
    var mediaId = variant && variant.featured_media_id != null ? String(variant.featured_media_id) : '';
    if (!mediaId) return;
    var slot = first(section, '[data-product-media-slot]');
    if (!slot || String(slot.dataset.activeMediaId) === mediaId) return;
    var template = first(section, '[data-media-template="' + mediaId + '"]');
    if (!template || !template.content) return;
    stopMedia(section);
    if (!reducedMotion) slot.classList.add('is-changing');
    slot.replaceChildren(template.content.cloneNode(true));
    slot.dataset.activeMediaId = mediaId;
    all(section, '[data-product-media-select]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.productMediaSelect === mediaId ? 'true' : 'false');
    });
    activateMedia(section);
    window.requestAnimationFrame(function () {
      slot.classList.remove('is-changing');
    });
  }

  function updateAvailabilityStates(section, variants, positions, selected) {
    optionControls(section).forEach(function (control) {
      var position = String(control.dataset.optionPosition || '');
      var value = control.dataset.optionValueName || '';
      var available = variants.some(function (variant) {
        var options = variant.options || [];
        if (!variant.available) return false;
        if (String(options[Number(position) - 1] == null ? '' : options[Number(position) - 1]) !== String(value)) return false;
        return positions.every(function (otherPosition) {
          if (otherPosition === position) return true;
          var selectedValue = selected[otherPosition];
          return selectedValue == null || String(options[Number(otherPosition) - 1] == null ? '' : options[Number(otherPosition) - 1]) === String(selectedValue);
        });
      });
      control.classList.toggle('is-unavailable', !available);
      control.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  }

  function updateUrl(section, variant, push) {
    if (!push || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    if (variant) url.searchParams.set('variant', variantId(variant));
    else url.searchParams.delete('variant');
    window.history.replaceState({ variant: variant ? variantId(variant) : null }, '', url.toString());
  }

  function labelFor(section, key, fallback) {
    return section.dataset[key] || fallback;
  }

  function updatePackageNote(section) {
    var note = first(section, '[data-package-note]:not(option)');
    var select = first(section, '[data-variant-select]');
    if (!note || !select) return;
    var option = select.options[select.selectedIndex];
    var text = !select.disabled && option ? option.dataset.packageNote || '' : '';
    note.textContent = text;
    note.hidden = !text.trim();
  }

  function updateProductState(section, variants, selected, pushUrl) {
    var positions = optionPositions(section);
    var variant = variantForSelection(variants, positions, selected);
    var select = first(section, '[data-variant-select]');
    var addButton = first(section, '[data-add-to-cart]');
    var availability = first(section, '[data-availability]');
    var addLabel = first(section, '[data-add-to-cart-label]');
    var liveRegion = first(section, '[data-product-live-region]');
    var dynamicCheckout = first(section, '[data-product-form] .product-form__dynamic-checkout');
    var available = Boolean(variant && variant.available);

    updateAvailabilityStates(section, variants, positions, selected);
    updateOptionLegends(section, selected);

    if (select) {
      select.value = variant ? variantId(variant) : '';
      select.disabled = !variant;
    }
    updatePackageNote(section);
    if (addButton) addButton.disabled = !available;
    if (dynamicCheckout) dynamicCheckout.hidden = !available;
    if (availability) {
      availability.textContent = variant
        ? (available ? labelFor(section, 'labelAvailable', '') : labelFor(section, 'labelSoldOut', ''))
        : labelFor(section, 'labelUnavailable', '');
    }
    if (addLabel) addLabel.textContent = available
      ? labelFor(section, 'labelAddToCart', '')
      : labelFor(section, 'labelUnavailable', '');
    if (liveRegion) {
      liveRegion.textContent = variant
        ? (available ? '' : labelFor(section, 'labelSoldOut', ''))
        : (positions.length ? labelFor(section, 'labelInvalidSelection', '') : '');
    }
    if (variant) {
      setPrice(section, variant);
      setMedia(section, variant);
    } else {
      clearPrice(section);
      setMedia(section, null);
    }
    updateUrl(section, variant, pushUrl);
    return variant;
  }

  function bindQuantity(section) {
    all(section, '[data-quantity-input]').forEach(function (quantity) {
      if (quantity.dataset.quantityInitialized === 'true') return;
      quantity.dataset.quantityInitialized = 'true';
      var input = first(quantity, '[data-quantity-value]');
      var decrease = first(quantity, '[data-quantity-decrease]');
      var increase = first(quantity, '[data-quantity-increase]');
      function normalize() {
        if (!input) return 1;
        var value = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = value;
        return value;
      }
      if (decrease) decrease.addEventListener('click', function () { if (input) input.value = Math.max(1, normalize() - 1); });
      if (increase) increase.addEventListener('click', function () { if (input) input.value = normalize() + 1; });
      if (input) input.addEventListener('change', normalize);
    });
  }

  function initProduct(section) {
    if (!section || section.dataset.productInitialized === 'true') return;
    section.dataset.productInitialized = 'true';
    bindQuantity(section);
    var mediaNavigation = first(section, '[data-product-media-navigation]');
    if (mediaNavigation) mediaNavigation.hidden = false;
    all(section, '[data-product-media-select]').forEach(function (button) {
      button.addEventListener('click', function () {
        setMedia(section, { featured_media_id: button.dataset.productMediaSelect });
      });
    });
    activateMedia(section);

    var variants = parseVariants(section);
    var limitExceeded = section.dataset.variantLimitExceeded === 'true';
    var optionPicker = first(section, '[data-product-options]');
    var fallback = first(section, '[data-variant-fallback]');
    var noteSelect = first(section, '[data-variant-select]');
    if (noteSelect) noteSelect.addEventListener('change', function () {
      updatePackageNote(section);
      if (limitExceeded || !variants.length) {
        var option = noteSelect.options[noteSelect.selectedIndex];
        if (option && option.value) setPrice(section, {
          price: option.dataset.price,
          price_formatted: option.dataset.priceFormatted,
          compare_at_price: option.dataset.compareAtPrice,
          compare_at_price_formatted: option.dataset.compareAtPriceFormatted,
          professional_price_formatted: option.dataset.professionalPriceFormatted
        });
        else clearPrice(section);
      }
    });
    if (limitExceeded || !variants.length) {
      if (optionPicker && limitExceeded) optionPicker.hidden = true;
      return;
    }
    var positions = optionPositions(section);
    if (!positions.length) return;
    if (fallback) fallback.hidden = true;

    var selected = selectedOptions(section);
    var urlVariantId = new URL(window.location.href).searchParams.get('variant');
    var byId = variantById(variants, urlVariantId);
    if (!urlVariantId) byId = variantById(variants, section.dataset.currentVariantId);
    if (byId) {
      selected = {};
      (byId.options || []).forEach(function (value, index) { selected[String(index + 1)] = String(value); });
      setSelectedOptions(section, selected);
    }
    updateProductState(section, variants, selected, false);
    if (urlVariantId && !byId) updateUrl(section, null, true);

    optionControls(section).forEach(function (control) {
      control.addEventListener('click', function () {
        var position = String(control.dataset.optionPosition || '');
        selected[position] = control.dataset.optionValueName || '';
        setSelectedOptions(section, selected);
        updateProductState(section, variants, selected, true);
      });
    });

    var select = first(section, '[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        var chosen = variantById(variants, select.value);
        if (chosen) {
          selected = {};
          (chosen.options || []).forEach(function (value, index) { selected[String(index + 1)] = String(value); });
          setSelectedOptions(section, selected);
        }
        updateProductState(section, variants, selected, true);
      });
    }

    var form = first(section, '[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (event) {
        var chosen = variantForSelection(variants, positions, selected);
        if (!chosen || !chosen.available) {
          event.preventDefault();
          updateProductState(section, variants, selected, false);
        }
      });
    }

    window.addEventListener('popstate', function () {
      var fromUrl = variantById(variants, new URL(window.location.href).searchParams.get('variant'));
      if (!fromUrl) fromUrl = variantById(variants, section.dataset.currentVariantId);
      if (!fromUrl) return;
      selected = {};
      (fromUrl.options || []).forEach(function (value, index) { selected[String(index + 1)] = String(value); });
      setSelectedOptions(section, selected);
      updateProductState(section, variants, selected, false);
    });
  }

  function initRecommendations(scope) {
    all(scope, '[data-related-products]').forEach(function (section) {
      if (section.dataset.recommendationsInitialized === 'true') return;
      section.dataset.recommendationsInitialized = 'true';
      if (first(section, '.related-products__grid')) return;
      var endpoint = section.dataset.recommendationsUrl;
      if (!endpoint || !window.fetch) return;
      fetch(endpoint, { headers: { Accept: 'text/html' } })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var incoming = first(wrapper, '[data-related-products]');
          if (!incoming || !first(incoming, '.related-products__grid')) return;
          section.replaceWith(incoming);
          initRecommendations(document);
        })
        .catch(function () {});
    });
  }

  function init(scope) {
    var root = scope || document;
    all(root, '[data-product-section]').forEach(initProduct);
    initRecommendations(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    all(event.target, '[data-product-section]').forEach(stopMedia);
    if (event.target && event.target.dataset) {
      delete event.target.dataset.productInitialized;
      delete event.target.dataset.recommendationsInitialized;
    }
  });
}());
